import {useEffect} from "react";

import useAsyncProcess from "../../../core/network/async-process/useAsyncProcess";
import {VerifiedAssets} from "../../util/assetModels";
import {DEFAULT_VERIFIED_ASSETS} from "../../util/assetConstants";
import assetApi from "../../api/assetApi";
import {PREFERRED_NETWORK} from "../../../core/constants";

function useFetchVerifiedAssets(): VerifiedAssets {
  const {state, runAsyncProcess} = useAsyncProcess<VerifiedAssets>({
    shouldResetDataWhenPending: false
  });

  useEffect(() => {
    runAsyncProcess(assetApi.listPeraLabeledAssets(PREFERRED_NETWORK));
  }, [runAsyncProcess]);

  return state.data || DEFAULT_VERIFIED_ASSETS;
}

export default useFetchVerifiedAssets;
